import { ButtonMantine, Card, Divider, Group, List, Stack, Text, ThemeIcon, Title } from 'ui';
import { IconDesktop, IconMobile } from 'ui/Icons';

import { useBreakPoints } from '../../../../../hooks';
import { MerchantType } from '../MerchantDetailModalsProvider';

type Props = {
  type?: MerchantType;
  onClick: () => void;
};

const OnlineBlueInfoCard = ({ onClick }: { onClick: () => void }) => {
  return (
    <Card bg="cobalt.0" radius="sm">
      <Stack gap="sm">
        <Title order={4}>How to Earn Cashback Online</Title>
        <List withPadding size="sm" listStyleType="disc">
          <List.Item>Simply navigate to the merchant&apos;s website</List.Item>
          <List.Item>Activate the offer by clicking the extension pop-up</List.Item>
          <List.Item>Start shopping!</List.Item>
        </List>
        <Divider color="cobalt.1" />
        <Stack gap="xs" pl="lg">
          <Group gap={4}>
            <ThemeIcon variant="transparent" c="gray.8" size="md">
              <IconMobile />
            </ThemeIcon>
            <Text type="sub" fw={500}>
              Mobile Shopping Notes
            </Text>
          </Group>
          <List withPadding size="xs" listStyleType="disc">
            <List.Item>For Apple: you must use the Safari browser to earn cash back</List.Item>
            <List.Item>For Android: you must use the Chrome browser to earn cash back</List.Item>
            <List.Item>
              You must shop on the merchant website, not the mobile app to earn cash back
            </List.Item>
          </List>
          <Group gap={4}>
            <ThemeIcon variant="transparent" c="gray.8" size="md">
              <IconDesktop />
            </ThemeIcon>
            <Text type="sub" fw={500}>
              Desktop Shopping Notes
            </Text>
          </Group>
          <List withPadding size="xs" listStyleType="disc">
            <List.Item>You must use use the Chrome web browser to get cash back</List.Item>
          </List>
        </Stack>
        <Group justify="flex-start">
          <ButtonMantine size="compact-sm" variant="subtle" onClick={onClick}>
            Offer Terms & Conditions
          </ButtonMantine>
        </Group>
      </Stack>
    </Card>
  );
};

const InStoreBlueInfoCard = ({ onClick }: { onClick: () => void }) => {
  const { isSmallScreen } = useBreakPoints();

  return (
    <Card bg="cobalt.0" radius="sm">
      <Stack gap="sm">
        <Title order={4}>How to Earn Cashback In-Store</Title>
        <List withPadding size={isSmallScreen ? 'xs' : 'sm'} listStyleType="disc">
          <List.Item>Add a credit or debit card to Givebacks</List.Item>
          <List.Item>Claim offer before you shop in store</List.Item>
          <List.Item>Pay in store with your linked card to earn cash back</List.Item>
        </List>
        <Group justify="flex-start">
          <ButtonMantine size="compact-sm" variant="subtle" onClick={onClick}>
            Offer Terms & Conditions
          </ButtonMantine>
        </Group>
      </Stack>
    </Card>
  );
};

const DiningBlueInfoCard = ({ onClick }: { onClick: () => void }) => {
  const { isSmallScreen } = useBreakPoints();
  return (
    <Card bg="cobalt.0" radius="sm">
      <Stack gap="sm">
        <Title order={4}>How to Earn Dining Cashback</Title>
        <List withPadding size={isSmallScreen ? 'xs' : 'sm'} listStyleType="disc">
          <List.Item>Add a credit or debit card to Givebacks</List.Item>
          <List.Item>Pay with your linked card to earn cash back</List.Item>
        </List>
        <Group justify="flex-start">
          <ButtonMantine size="compact-xs" variant="subtle" onClick={onClick}>
            Offer Terms & Conditions
          </ButtonMantine>
        </Group>
      </Stack>
    </Card>
  );
};

const MerchantBlueInfoCard = ({ type, onClick }: Props) => {
  switch (type) {
    case 'online':
      return <OnlineBlueInfoCard onClick={onClick} />;
    case 'instore':
      return <InStoreBlueInfoCard onClick={onClick} />;
    case 'dining':
      return <DiningBlueInfoCard onClick={onClick} />;
  }
};

export { MerchantBlueInfoCard };
